import React from "react";
import { FormControl, Select, MenuItem, Typography } from "@mui/material";
import "../CustomStyle.css"; 

const TemplateSelector = ({
  selectedTemplate,
  handleSelect,
  initialMessage,
}) => {
  const dropdownStyles = {
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "14px",
    backgroundColor: "#f9f9f9",
    "&:hover": {
      backgroundColor: "#f1f1f1",
    },
  };

  return (
    <div>
      <FormControl style={{ width: "100%" }}>
        <Typography variant="body2" className="template-subheading">
          Begin with:
        </Typography>

        <Select
          value={selectedTemplate}
          style={dropdownStyles}
          displayEmpty
          onChange={handleSelect}
        >
          <MenuItem value="" disabled>
            Choose a Template
          </MenuItem>
          <MenuItem value="Agent Letter - Biro">Agent Letter - Biro</MenuItem>
          <MenuItem value="Agent Letter - Typed">Agent Letter - Typed</MenuItem>
          <MenuItem value="Envelope #10">Envelope #10</MenuItem>
          <MenuItem value="Cash Offer - Biro">Cash Offer - Biro</MenuItem>
          <MenuItem value="Cash Offer - Typed">Cash Offer - Typed</MenuItem>

        </Select>
      </FormControl>
      {initialMessage && (
        <div style={{ marginTop: "2%" }}>
          <Typography variant="body2" className="proof-subheading">
            {initialMessage}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default TemplateSelector;
